/* MD Masala theme by Zoon Network · zoon.network */
(function () {
  'use strict';
  if (window.MD_PDP_BOOT) return;
  var doc = document;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ROOT = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var money = function (cents) {
    var c = Math.round(cents), p = c % 100;
    return '₹' + Math.floor(c / 100).toLocaleString('en-IN') + (p ? '.' + ('0' + p).slice(-2) : '');
  };
  var live = null;

  function boot(scope) {
    var root = scope && scope.matches && scope.matches('[data-pdp]') ? scope : (scope || doc).querySelector('[data-pdp]');
    if (!root) return null;
    if (live) live.stop();
    var $ = function (s, c) { return (c || doc).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var on = function (target, type, fn, opts) {
      var o = opts || {};
      if (ac) o.signal = ac.signal;
      target.addEventListener(type, fn, o);
    };
    var observers = [];
    var host = root.closest('.shopify-section') || root.parentNode || doc;
    var data = {};
    try { data = JSON.parse(($('[data-pdp-json]', host) || $('[data-pdp-json]') || {}).textContent || '{}'); } catch (e) { data = {}; }
    var variants = data.variants || [];
    var inst = { root: root, refresh: function () {}, stop: function () {
      if (ac) ac.abort();
      observers.forEach(function (o) { o.disconnect(); });
      doc.body.classList.remove('mdpdp-bar-on');
    } };

    var gal = $('[data-pdp-gal]', root), track = gal && $('[data-pdp-slides]', gal);
    var slides = track ? $$(':scope > li', track) : [];
    var thumbs = gal ? $$('[data-pdp-thumb]', gal) : [], dots = gal ? $$('[data-pdp-dots] span', gal) : [];
    var prev = gal && $('[data-pdp-dir="-1"]', gal), next = gal && $('[data-pdp-dir="1"]', gal);
    var at = 0, tcol = gal && $('[data-pdp-tcol]', gal), tlist = gal && $('[data-pdp-tlist]', gal), tdown = gal && $('[data-pdp-tdown]', gal);
    function index() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
    function paint(k) {
      at = k;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === k ? 'true' : 'false'); });
      if (tlist && thumbs[k]) {
        var tt = thumbs[k].offsetTop, tb = tt + thumbs[k].offsetHeight;
        if (tt < tlist.scrollTop || tb > tlist.scrollTop + tlist.clientHeight) tlist.scrollTo({ top: tt - 4, behavior: reduced.matches ? 'auto' : 'smooth' });
      }
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
      if (prev) prev.disabled = k <= 0;
      if (next) next.disabled = k >= slides.length - 1;
    }
    function go(k, instant) {
      if (!track || !slides.length) return;
      k = Math.max(0, Math.min(slides.length - 1, k));
      track.scrollTo({ left: k * track.clientWidth, behavior: instant || reduced.matches ? 'auto' : 'smooth' });
      paint(k);
    }
    if (track && slides.length) {
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-pdp-thumb')); }); });
      [prev, next].forEach(function (b) { if (b) b.addEventListener('click', function () { go(index() + +b.getAttribute('data-pdp-dir')); }); });
      var raf = 0;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { var k = index(); if (k !== at) paint(k); }); }, { passive: true });
      on(window, 'resize', function () { go(at, true); });
      gal.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (e.target.closest && e.target.closest('input')) return;
        e.preventDefault(); go(at + (e.key === 'ArrowRight' ? 1 : -1));
      });
      paint(0);
    }
    if (tlist && tdown && tcol) {
      var tFit = function () {
        tcol.classList.add('has-more');
        var more = tlist.scrollHeight > tlist.clientHeight + 2;
        tcol.classList.toggle('has-more', more); tdown.hidden = !more;
        tdown.classList.toggle('is-up', more && tlist.scrollTop + tlist.clientHeight >= tlist.scrollHeight - 2);
      };
      tdown.addEventListener('click', function () {
        var up = tdown.classList.contains('is-up');
        tlist.scrollBy({ top: up ? -tlist.scrollHeight : tlist.clientHeight * .7, behavior: reduced.matches ? 'auto' : 'smooth' });
      });
      tlist.addEventListener('scroll', function () { tdown.classList.toggle('is-up', tlist.scrollTop + tlist.clientHeight >= tlist.scrollHeight - 2); }, { passive: true });
      if (typeof ResizeObserver === 'function') { var tro = new ResizeObserver(tFit); tro.observe(tcol); observers.push(tro); }
      tFit();
    }

    var dlg = $('[data-pdp-dialog]', root), zImg = dlg && $('[data-pdp-zoom-img]', dlg), zAt = 0, opener = null;
    function zShow(k) {
      k = (k + slides.length) % slides.length; zAt = k;
      var im = $('img', slides[k]); if (!im || !zImg) return;
      zImg.src = im.getAttribute('data-full') || im.currentSrc || im.src; zImg.alt = im.alt;
    }
    if (dlg && typeof dlg.showModal === 'function') {
      $$('[data-pdp-zoom]', root).forEach(function (b) {
        b.addEventListener('click', function () { opener = b; zShow(+b.getAttribute('data-pdp-zoom')); dlg.showModal(); });
      });
      var zc = $('[data-pdp-zoomcur]', root);
      if (zc) zc.addEventListener('click', function () { opener = zc; zShow(at); dlg.showModal(); });
      $$('[data-pdp-zdir]', dlg).forEach(function (b) { b.addEventListener('click', function () { zShow(zAt + +b.getAttribute('data-pdp-zdir')); }); });
      $('[data-pdp-close]', dlg).addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('keydown', function (e) {
        if (slides.length < 2) return;
        if (e.key === 'ArrowLeft') zShow(zAt - 1); else if (e.key === 'ArrowRight') zShow(zAt + 1);
      });
      dlg.addEventListener('close', function () { go(zAt, true); if (opener) opener.focus({ preventScroll: true }); });
    }

    var form = $('[data-pdp-form]', root);
    if (!form) return inst;
    var qtyIn = $('[data-pdp-qty]', form), msg = $('[data-pdp-msg]', form);
    var addBtn = $('[data-pdp-add]', form), nowBtn = $('[data-pdp-now]', form);
    var bar = $('[data-pdp-bar]', root), barAdd = bar && $('[data-pdp-bar-add]', bar);
    function picked() {
      var r = $('input[name="id"]:checked', form) || $('input[name="id"][type="hidden"]', form);
      var id = r ? +r.value : 0;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0] || null;
    }
    function render(user) {
      var v = picked(); if (!v) return;
      $$('[data-pdp-price]').forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-pdp-mrp]').forEach(function (el) { el.textContent = money(v.compare > v.price ? v.compare : v.price); });
      $$('[data-pdp-size], [data-pdp-net]').forEach(function (el) { el.textContent = v.title; });
      $$('[data-pdp-unit]').forEach(function (el) {
        el.hidden = !(v.unit > 0 && data.unit_label);
        if (!el.hidden) el.textContent = String(data.unit_label).split('{price}').join(money(v.unit));
      });
      var cmp = $('[data-pdp-compare]', root);
      if (cmp) { cmp.hidden = !(v.compare > v.price); cmp.textContent = v.compare > v.price ? money(v.compare) : ''; }
      [addBtn, barAdd].forEach(function (b) {
        if (!b) return;
        b.disabled = !v.available;
        var t = $('[data-pdp-add-t]', b);
        if (t) t.textContent = v.available ? (b === barAdd ? data.bar_add || data.add : data.add) || t.textContent : data.sold_out || t.textContent;
      });
      if (nowBtn) nowBtn.hidden = !v.available;
      if (msg) msg.textContent = '';
      if (user && history.replaceState && variants.length > 1) {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {  }
      }
      if (user && v.media) { slides.forEach(function (s, k) { if (+s.getAttribute('data-media-id') === v.media) go(k); }); }
    }
    inst.refresh = function () { render(false); };
    $$('input[name="id"]', form).forEach(function (r) { r.addEventListener('change', function () { render(true); }); });

    function qty() { var q = parseInt(qtyIn && qtyIn.value, 10); return Math.max(1, Math.min(20, isNaN(q) ? 1 : q)); }
    $$('[data-pdp-q]', form).forEach(function (b) {
      b.addEventListener('click', function () { if (qtyIn) qtyIn.value = Math.max(1, Math.min(20, qty() + +b.getAttribute('data-pdp-q'))); });
    });
    if (qtyIn) qtyIn.addEventListener('change', function () { qtyIn.value = qty(); });

    var box = $('[data-pdp-box]', root), cartEl = doc.getElementById('cart');
    var busyBtn = null, busyT = 0, lastAdd = null;
    function done() { if (busyBtn) { busyBtn.classList.remove('is-busy'); busyBtn.removeAttribute('aria-busy'); } busyBtn = null; clearTimeout(busyT); }
    if (cartEl && 'MutationObserver' in window) {
      var wasBusy = false;
      var mo = new MutationObserver(function () {
        var b = cartEl.classList.contains('is-busy');
        if (wasBusy && !b) done();
        wasBusy = b;
        var ae = doc.activeElement;
        if (cartEl.hidden && lastAdd && (!ae || ae === doc.body || cartEl.contains(ae) || ae === box)) lastAdd.focus({ preventScroll: true });
      });
      mo.observe(cartEl, { attributes: true, attributeFilter: ['class', 'hidden'] });
      observers.push(mo);
    }
    function add(btn) {
      var v = picked(); if (!v || !v.available || !box) return false;
      var q = qty(), items = [], ids = [];
      for (var i = 0; i < q; i++) { items.push((data.handle || 'pdp') + '|' + v.title); ids.push(v.id); }
      box.setAttribute('data-box-items', items.join(';'));
      box.setAttribute('data-box-variants', ids.join(','));
      if (msg) msg.textContent = '';
      lastAdd = btn; busyBtn = btn; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
      busyT = setTimeout(done, 8000);
      box.click();
      return true;
    }
    form.addEventListener('submit', function (e) {
      var sub = e.submitter;
      var v = picked();
      if (!v || !v.available) { e.preventDefault(); return; }
      if (sub && sub === nowBtn) {
        e.preventDefault();
        nowBtn.classList.add('is-busy'); nowBtn.setAttribute('aria-busy', 'true');
        fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: qty() }] }) })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { window.location.href = ROOT + 'checkout'; })
          .catch(function (err) {
            nowBtn.classList.remove('is-busy'); nowBtn.removeAttribute('aria-busy');
            if (msg) msg.textContent = (err && (err.description || err.message)) || data.error || '';
          });
        return;
      }
      if (location.protocol === 'file:' && !box) return;
      if (add(addBtn)) e.preventDefault();
    });
    if (barAdd) barAdd.addEventListener('click', function () { add(barAdd); });

    var pair = $('[data-pdp-pair]', root);
    if (pair && box) {
      var pairBtn = $('[data-pdp-pair-add]', pair), pairMsg = $('[data-pdp-pair-msg]', pair);
      pair.addEventListener('submit', function (e) {
        if (location.protocol === 'file:' && !box) return;
        var ids = (pair.getAttribute('data-ids') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        e.preventDefault();
        if (pairMsg) pairMsg.textContent = '';
        box.setAttribute('data-box-items', pair.getAttribute('data-items') || '');
        box.setAttribute('data-box-variants', ids.join(','));
        lastAdd = pairBtn; busyBtn = pairBtn; pairBtn.classList.add('is-busy'); pairBtn.setAttribute('aria-busy', 'true');
        clearTimeout(busyT); busyT = setTimeout(done, 8000);
        box.click();
      });
    }

    if (bar) {
      bar.hidden = false;
      var row = $('.mdpdp__row', form) || addBtn, barOn = null, barRaf = 0;
      var check = function () {
        var shown = row.getBoundingClientRect().bottom < 0;
        if (shown === barOn) return;
        barOn = shown;
        bar.classList.toggle('is-on', shown);
        bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
        if (shown) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
        doc.body.classList.toggle('mdpdp-bar-on', shown && getComputedStyle(bar).display !== 'none');
      };
      var onScroll = function () { cancelAnimationFrame(barRaf); barRaf = requestAnimationFrame(check); };
      on(window, 'scroll', onScroll, { passive: true });
      on(window, 'resize', onScroll);
      check();
    }

    render();
    return inst;
  }

  live = boot(doc);
  window.MD_PDP_BOOT = function (scope) { live = boot(scope) || live; return live; };

  if (window.Shopify && window.Shopify.designMode) {
    doc.addEventListener('shopify:section:unload', function (e) {
      if (live && e.target && e.target.contains(live.root)) { live.stop(); live = null; }
    });
    doc.addEventListener('shopify:section:load', function (e) {
      var t = e.target;
      try {
        if (t.querySelector('[data-pdp]')) live = boot(t);
        else if (live && t.querySelector('[data-pdp-net], [data-pdp-mrp], [data-pdp-price], [data-pdp-size]')) live.refresh();
      } catch (err) { console.error('product page set-up after an edit', err); }
    });
    var opened = null, pinned = null;
    doc.addEventListener('shopify:block:select', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-pdp-bar]');
      if (b) {
        pinned = { el: b, was: b.classList.contains('is-on') };
        b.classList.add('is-on'); b.removeAttribute('inert'); b.setAttribute('aria-hidden', 'false');
        return;
      }
      var d = e.target && e.target.closest && e.target.closest('details.mdpdpf__item');
      if (!d) return;
      if (!d.open) { d.open = true; opened = d; }
      try { d.scrollIntoView({ block: 'nearest' }); } catch (err) {  }
    });
    doc.addEventListener('shopify:block:deselect', function (e) {
      if (pinned && e.target && (e.target === pinned.el || pinned.el.contains(e.target))) {
        if (!pinned.was) { pinned.el.classList.remove('is-on'); pinned.el.setAttribute('inert', ''); pinned.el.setAttribute('aria-hidden', 'true'); }
        pinned = null;
      }
      if (opened && e.target && (e.target === opened || opened.contains(e.target))) { opened.open = false; opened = null; }
    });
  }
})();

(function () {
  'use strict';
  var SEL = '.mdpdp,.mdpdpi,.mdpdpm,.mdpdpg,.mdpdpf,.mdpdpl,.mdpdpr';
  var mq = window.matchMedia('(min-width: 900px) and (min-height: 560px)');
  var raf = 0;
  function inner(s) {
    for (var i = 0; i < s.children.length; i++) { if (/__in(\s|$)/.test(s.children[i].className)) return s.children[i]; }
    return null;
  }
  function smallest(box) {
    var min = 99, els = box.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], txt = false;
      for (var c = el.firstChild; c; c = c.nextSibling) { if (c.nodeType === 3 && c.nodeValue.trim()) { txt = true; break; } }
      if (!txt || el.closest('[aria-hidden="true"]') || !el.getClientRects().length) continue;
      var fs = parseFloat(getComputedStyle(el).fontSize) || 99;
      for (var p = el; p && p !== box; p = p.parentElement) { fs *= parseFloat(getComputedStyle(p).zoom) || 1; }
      if (fs < min) min = fs;
    }
    return min;
  }
  function fit() {
    raf = 0;
    var sh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-h')) || 0;
    var target = window.innerHeight - sh;
    var secs = document.querySelectorAll(SEL);
    for (var i = 0; i < secs.length; i++) {
      var s = secs[i], box = s.matches('.mdpdpg,.mdpdpl') ? (s.querySelector('.mdpdpg__body,.mdpdpl__body') || inner(s)) : inner(s);
      if (!box) continue;
      box.style.zoom = '';
      if (!mq.matches) continue;
      var cs = getComputedStyle(s);
      var pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
      var h = box.offsetHeight;
      if (!(h + pad > target + 1 && h > 0)) continue;
      var floor = Math.min(1, Math.max(0.55, 12 / smallest(box)));
      var z = Math.max(floor, (target - pad) / h);
      box.style.zoom = z.toFixed(4);
      for (var k = 0; k < 4; k++) {
        var got = s.getBoundingClientRect().height;
        if (got <= target + 1 || z <= floor) break;
        z = Math.max(floor, z * (target - pad) / Math.max(1, got - pad));
        box.style.zoom = z.toFixed(4);
      }
    }
  }
  function later() { if (!raf) raf = requestAnimationFrame(fit); }
  window.addEventListener('resize', later);
  window.addEventListener('load', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
  if (mq.addEventListener) mq.addEventListener('change', later);
  document.addEventListener('shopify:section:load', function () { setTimeout(fit, 60); });
  if (document.readyState !== 'loading') later(); else document.addEventListener('DOMContentLoaded', later);
  setTimeout(later, 1200);
})();
